import { InvitationAccessLevel, InvitationStatusType } from '@vi-iot/client/index';
import {
  FetchedPartnerAccessInvitation,
  PartnerAccessInvitationFormData,
} from './commercial.model';

export namespace CommercialHelper {
  export function checkCustomerInvitationPresent(
    invitationsToSend: PartnerAccessInvitationFormData[],
    fetchedInvitations: FetchedPartnerAccessInvitation[]
  ): boolean {
    return (
      isCustomerInvitationStatusPresent(fetchedInvitations) ||
      isCustomerInvitationPresent(invitationsToSend)
    );
  }

  export function isCustomerInvitationStatusPresent(
    fetchedInvitations: FetchedPartnerAccessInvitation[]
  ): boolean {
    const customerInvitation =
      fetchedInvitations?.length > 0
        ? fetchedInvitations.find(
            (invitation) => invitation.accessLevel === InvitationAccessLevel.Consumer
          )
        : null;

    return customerInvitation
      ? [InvitationStatusType.Accepted, InvitationStatusType.Pending].includes(
          customerInvitation.status
        )
      : false;
  }

  export function isCustomerInvitationPresent(
    invitationsToSend: PartnerAccessInvitationFormData[]
  ): boolean {
    return invitationsToSend.length > 0
      ? invitationsToSend.some(
          (invitation) => invitation.accessLevel === InvitationAccessLevel.Consumer
        )
      : false;
  }
}
